<template>
  <div class="bc active protocol-bc">
    <div class="protocol">
      <div class="protocol-header" v-if="title">
        <h5>{{title}}</h5>
        <span class="subtitle" v-if="subtitle">{{subtitle}}</span>
      </div>
      <div class="protocol-main">
        <slot></slot>
      </div>
      <button class="btn-main btn-next" v-if="btnText" @click="clickButton">{{btnText}}</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "info-modal",
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    subtitle: {
      type: String,
      required: false,
      default: ""
    },
    btnText: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    clickButton() {
      this.$emit("btn-click");
    }
  }
};
</script>

<style lang="less">

.bc {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  margin: auto;
  opacity: 0;
  transition: all 0.2s;
  z-index: -1;

  &.active {
    z-index: 1;
    opacity: 1;
  }
}

.protocol-bc {
  padding: 24 / @rem-size;

  .protocol {
    width: 100%;
    overflow-y: scroll;
    background: #fff;
    height: auto;
    max-height: 100%;
    padding-bottom: 25 / @rem-size;

    .protocol-header {
      padding: 32 / @rem-size 0 25 / @rem-size;
      border-bottom: 1px solid #e5e5e5;

      h5 {
        padding: 0;
        margin: 0;
        font-size: 36 / @rem-size;
        color: #333;
        text-align: center;
        font-weight: normal;
      }

      span.subtitle {
        color: #999;
        font-size: 24 / @rem-size;
        display: block;
        margin-top: 20 / @rem-size;
        text-align: center;
      }
    }

    .protocol-main {
      padding-top: 18 / @rem-size;
      padding-bottom: 40 / @rem-size;

      span {
        font-size: 30 / @rem-size;
      }

      p {
        padding: 0 18 / @rem-size;
        text-align: left;
        font-size: 28 / @rem-size;
        color: #333333;
        line-height: 40 / @rem-size;
      }

      .account-info {
        font-size: 28 / @rem-size;
        color: #333333;
        line-height: 40 / @rem-size;
        padding: 0 18 / @rem-size;

        span {
          text-align: left;
          font-size: 28 / @rem-size;
          color: #333333;
          line-height: 40 / @rem-size;
        }

        .info {
          span {
            float: left;
            max-width: 520 / @rem-size;
          }
        }
      }
    }

    .protocol-footer {
      padding: 0 18 / @rem-size;
      margin-top: 30 / @rem-size;

      span {
        text-align: right;
        line-height: 42 / @rem-size;
      }
    }
  }
}

.btn-next {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  border-radius: 8 / @rem-size;
  margin: 0 auto;
  color: #fff;
  font-size: 28 / @rem-size;

  &:active {
    background: #005fd5 - 10%;
  }
}
</style>
